// extracted by mini-css-extract-plugin
export default {"logo":"Pages_logo__3k9fw","loginButton":"Pages_loginButton__DQJ1x","continer":"Pages_continer__OvoVY","page":"Pages_page__mryv2"};